import React, { useEffect, useState, useContext } from "react";
import { useHistory } from "react-router-dom";
import { makeStyles } from "@material-ui/core/styles";
import Paper from "@material-ui/core/Paper";
import Typography from "@material-ui/core/Typography";
import CircularProgress from "@material-ui/core/CircularProgress";
import Button from "@material-ui/core/Button";
import Box from "@material-ui/core/Box";

import MainContainer from "../../components/MainContainer";
import MainHeader from "../../components/MainHeader";
import Title from "../../components/Title";
import api from "../../services/api";
import { AuthContext } from "../../context/Auth/AuthContext";

const useStyles = makeStyles((theme) => ({
  mainPaper: {
    flex: 1,
    padding: theme.spacing(6),
    margin: theme.spacing(1),
    textAlign: "center",
    ...theme.scrollbarStyles,
  },
}));

const POLL_INTERVAL = 5000; // 5 seconds
const TIMEOUT = 120000; // 2 minutes

const PaymentProcessing = () => {
  const classes = useStyles();
  const history = useHistory();
  const { setUser } = useContext(AuthContext);
  const [timedOut, setTimedOut] = useState(false);

  useEffect(() => {
    let active = true;
    const start = Date.now();

    const poll = async () => {
      if (!active) return;

      if (Date.now() - start > TIMEOUT) {
        setTimedOut(true);
        return;
      }

      try {
        const { data } = await api.get("/auth/me");
        const company = data?.user?.company;
        if (company && company.status === true) {
          // Payment confirmed — update user context and redirect
          setUser(data.user);
          history.push("/tickets");
          return;
        }
      } catch {
        // Ignore errors during polling (402 is expected while inactive)
      }

      if (active) {
        setTimeout(poll, POLL_INTERVAL);
      }
    };

    poll();

    return () => {
      active = false;
    };
  }, [history, setUser]);

  return (
    <MainContainer>
      <MainHeader>
        <Title>Processando Pagamento</Title>
      </MainHeader>
      <Paper className={classes.mainPaper} variant="outlined">
        {timedOut ? (
          <>
            <Typography variant="h6" gutterBottom>
              O processamento está demorando mais que o esperado.
            </Typography>
            <Typography variant="body1" color="textSecondary" gutterBottom>
              Seu pagamento pode levar alguns minutos para ser confirmado.
              Tente atualizar a página ou voltar mais tarde.
            </Typography>
            <Box mt={3}>
              <Button
                variant="contained"
                color="primary"
                onClick={() => window.location.reload()}
              >
                Atualizar Página
              </Button>
            </Box>
          </>
        ) : (
          <>
            <CircularProgress size={48} />
            <Box mt={3}>
              <Typography variant="h6" gutterBottom>
                Processando seu pagamento...
              </Typography>
              <Typography variant="body1" color="textSecondary">
                Aguarde enquanto confirmamos seu pagamento. Isso pode levar
                alguns segundos.
              </Typography>
            </Box>
          </>
        )}
      </Paper>
    </MainContainer>
  );
};

export default PaymentProcessing;
